export function getApplicationManagerName(employees) {
  const applicationManager = employees.find((employee) => employee.role === 'applicationManager');
  if (!applicationManager) {
    return 'application manager';
  }
  const { firstName, lastName } = applicationManager.contactInfo;
  if (!firstName || !lastName) {
    return 'application manager';
  }
  return `application manager ${firstName} ${lastName}`;
}

export const ERROR_MSGS = {
  IS_APPLICATION_MANAGER: 'Current user is application manager',
  APPLICATION_MANAGER_ALREADY_ID_VERIFIED: 'Application manager is already id verified',
};
